<template>
    <div>
        <div class="rank-relevant-list" :data-pblog="pblog">
            <div class="rank-relevant-list-title">
                {{ info.appName }}相关热门榜单
            </div>
            <div class="rank-relevant-list-tab">
                <div
                    :class="currentTabIndex === 0 ?
                        'rank-relevant-list-tab-active' : 'rank-relevant-list-tab-no-active'"
                    :style="{color: currentTabIndex === 0 ? '#3388FF' : '#1F1F1F'}"
                    @click="currentTab(0)"
                >
                    <span>{{ leftTab }}</span>
                </div>
                <div
                    :class="currentTabIndex === 1 ?
                        'rank-relevant-list-tab-active' : 'rank-relevant-list-tab-no-active'"
                    :style="{color: currentTabIndex === 1 ? '#3388FF' : '#1F1F1F'}"
                    @click="currentTab(1)"
                >
                    <span>{{ rightTab }}</span>
                </div>
            </div>
            <div class="rank-relevant-list-content">
                <div
                    v-for="(item, index) in rankListArr"
                    :key="index"
                    class="rank-relevant-list-item"
                    @click.stop="jumpToZone(item)"
                >
                    <img
                        v-if="index < 3"
                        :src="numArr[index]"
                        alt=""
                        class="rank-relevant-list-item-num"
                    >
                    <p
                        v-else
                        :class="index < 9 ? 'rank-relevant-list-num-else' : 'rank-relevant-list-num-else-long'"
                    >{{ index + 1 }}</p>
                    <img
                        :src="item.icon"
                        class="rank-relevant-list-item-icon"
                    >
                    <div class="rank-relevant-list-item-desc">
                        <div class="rank-relevant-list-item-name">{{ item.title }}</div>
                        <div class="rank-relevant-list-item-recommend">
                            <span class="rank-relevant-list-item-recommend-num">{{ item.sub_info2 }}</span>
                        </div>
                        <div class="rank-relevant-list-item-recommend-reason">
                            <span class="rank-relevant-list-item-recommend-reason-left">推荐理由:</span>
                            <span class="rank-relevant-list-item-recommend-reason-right">{{ item.desc }}</span>
                        </div>
                    </div>
                    <div
                        class="rank-relevant-list-item-download-btn"
                        @click.stop="download(item)"
                    >
                        {{ item.ext_info.button_txt }}
                    </div>
                </div>
            </div>
            <div
                v-if="rankList[currentTabIndex].app_list.length > 6" class="showMore"
                @click="showMore"
            >
                <div class="showMoreWords">
                    {{ isShowMore ? '展开' : '收起' }}
                </div>
                <img
                    :src="isShowMore ? downicon : upicon" alt=""
                    class="showMoreIcon"
                >
            </div>
        </div>
    </div>
</template>

<script>
import {getQueryString} from '@/utils/url';
import ck from '@/utils/ck';
import num_1 from 'public/assets/imgs/num1.png';
import num_2 from 'public/assets/imgs/num2.png';
import num_3 from 'public/assets/imgs/num3.png';
import downIcon from 'public/assets/imgs/ic_down_grey.png';
import upIcon from 'public/assets/imgs/ic_up_grey.png';
import {on, off} from '@/utils/dom';
import {debounce} from 'throttle-debounce';

export default {
    props: {
        rankTitle: {
            type: String,
            default: '',
        },
        rankListTab: {
            type: Number,
            default: 0,
        },
        rankList: {
            type: Array,
            default: () => [],
        },
        info: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            currentTabIndex: 0,
            numArr: [num_1, num_2, num_3],
            downicon: downIcon,
            upicon: upIcon,
            isShowMore: true,
            leftTab: '',
            rightTab: '',
            ckUtil: '',
            ckUtil2: '',
            rankListArr: [],
        };
    },
    computed: {
        // 模块展现参数
        pblog() {
            return JSON.stringify({
                gameName: this.info.appName,
                gameId: this.info.appId,
                moduleName: '相关热门榜单',
                tabName: [this.leftTab, this.rightTab],
                sid: getQueryString('sid') || '',
                srcId: getQueryString('srcid') || '',
                channelid: getQueryString('channelid') || '',
            });
        },
    },
    watch: {
        rankListTab: {
            handler() {
                this.currentTabIndex = this.rankListTab;
            },
        },
        currentTabIndex: {
            handler() {
                this.isShowMore = true;
                this.rankListArr = this.rankList[this.currentTabIndex].app_list.slice(0, 6);
            },
        },
        rankList: {
            handler() {
                this.leftTab = decodeURI(this.rankList[0].rank_name);
                this.rightTab = decodeURI(this.rankList[1].rank_name);
                this.rankListArr = this.rankList[this.currentTabIndex].app_list.slice(0, 6);
            },
        },
    },
    mounted() {
        this.ckUtil = ck().getInstance('.rank-relevant-list-item-download-btn');
        this.ckUtil2 = ck().getInstance('.rank-relevant-list-item');
        this.$nextTick(() => {
            on(window, 'scroll', debounce(500, this.moduleShowLog));
        });
    },
    beforeDestroy() {
        // 移除滚动监听事件
        off(window, 'scroll', this.moduleShowLog);
    },
    methods: {
        download(item) {
            if (item.ext_info.button_txt === '下载') {
                if (item.is_adv === 1) {
                    const {imTimeSign, landing_url2} = item.ext_info;
                    const ckUrl = this.ckUtil.addCkOnUrl(landing_url2, imTimeSign); // 生成ck计费下载链接
                    const img = document.createElement('img');
                    img.src = ckUrl; // 绕过计费串请求链接的跨域问题
                    img.setAttribute('style', 'display:none');
                    document.body.appendChild(img);
                    setTimeout(() => {
                        window.location.href = landing_url2;
                    }, 200);
                }
                else {
                    window.location.href = item.jump_url;
                }
            }
            if (item.ext_info.button_txt === '进入') {
                window.location.href = item.jump_url;
            }
            this.doClickLog(item, 'downloadClick');
        },
        currentTab(index) {
            this.currentTabIndex = index;
            this.doTabClickLog(index);
        },
        showMore() {
            if (this.isShowMore) {
                this.rankListArr = this.rankList[this.currentTabIndex].app_list;
                this.isShowMore = !this.isShowMore;
            }
            else {
                this.rankListArr = this.rankList[this.currentTabIndex].app_list.slice(0, 6);
                this.isShowMore = !this.isShowMore;
            }
            this.$logger.click({
                type: 'click',
                value: !this.isShowMore ? 'showMoreClick' : 'foldMoreClick',
                ext: {
                    item: [
                        {
                            ext: {
                                gameName: this.info.appName,
                                gameId: this.info.appId,
                                tabName: this.rankList[this.currentTabIndex].rank_name,
                                sid: getQueryString('sid') || '',
                                srcId: getQueryString('srcid') || '',
                                channelid: getQueryString('channelid') || '',
                            },
                        },
                    ],
                },
            });
        },
        jumpToZone(item) {
            this.doClickLog(item, 'gameRankItem');
            if (item.is_adv === 1) {
                const {landing_url} = item;
                const {imTimeSign} = item.ext_info;
                const ckUrl2 = this.ckUtil2.addCkOnUrl(landing_url, imTimeSign); // 生成ck计费下载链接
                const img2 = document.createElement('img');
                img2.src = ckUrl2; // 绕过计费串请求链接的跨域问题
                img2.setAttribute('style', 'display:none');
                document.body.appendChild(img2);
                window.location.href = landing_url;
            }
            else {
                window.location.href = item.jump_url;
            }
            this.doClickLog(item, 'gameRankItem');
        },
        moduleShowLog() {
            this.$logger.inScreen('.rank-relevant-list', dataset => {
                const {gameName, moduleName, gameId, tabName} = dataset;
                const ext = {
                    ext: {
                        gameName,
                        moduleName,
                        gameId,
                        tabName,
                        sid: getQueryString('sid') || '',
                        srcId: getQueryString('srcid') || '',
                        channelid: getQueryString('channelid') || '',
                    },
                };
                this.$logger.display({
                    value: 'module',
                    ext: {
                        item: [
                            {
                                ...ext,
                            },
                        ],
                    },
                });
            });
        },
        doClickLog(item, val) {
            this.$logger.click({
                type: 'click',
                value: val,
                ext: {
                    item: [
                        {
                            ext: {
                                gameName: item.app_name,
                                gameId: item.app_id,
                                tabName: this.rankList[this.currentTabIndex].rank_name,
                                is_adv: item.is_adv === 1,
                                moduleName: '相关热门榜单',
                                sid: getQueryString('sid') || '',
                                srcId: getQueryString('srcid') || '',
                                channelid: getQueryString('channelid') || '',
                            },
                        },
                    ],
                },
            });
        },
        doTabClickLog(index) {
            this.$logger.click({
                type: 'click',
                value: 'rankTabChange',
                ext: {
                    item: [
                        {
                            ext: {
                                moduleName: '相关热门榜单', // 模块名称：游戏榜单
                                tabName: index === 1 ? this.rightTab : this.leftTab, // 榜单名称
                                gameName: this.info.appName,
                                gameId: this.info.appId,
                                sid: getQueryString('sid') || '',
                                srcId: getQueryString('srcid') || '',
                                channelid: getQueryString('channelid') || '',
                            },
                        },
                    ],
                },
            });
        },
    },
};
</script>

<style lang="scss">
.rank-relevant-list {
    margin: 0 51px;
    overflow: hidden;
    .rank-relevant-list-title {
        height: 60px;
        font-family: PingFangSC-Medium;
        font-size: 57px;
        color: #000000;
        letter-spacing: 0;
        line-height: 60px;
        font-weight: 500;
        margin-bottom: 45px;
    }
    .rank-relevant-list-tab {
        width: 1140px;
        height: 108px;
        background: #F5F5F5;
        border-radius: 27px;
        display: flex;
        align-items: center;
        margin-bottom: 55px;
        justify-content: space-around;
        .rank-relevant-list-tab-active {
            width: 558px;
            height: 96px;
            background: #FFFFFF;
            box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.1);
            border-radius: 22px;
            text-align: center;
            font-family: PingFangSC-Medium;
            font-size: 42px;
            // color: #47B1B3;
            letter-spacing: 0;
            text-align: center;
            line-height: 96px;
            font-weight: 500;
            white-space: nowrap;
            text-overflow:ellipsis;
            overflow: hidden;
        }
        .rank-relevant-list-tab-no-active {
            width: 558px;
            height: 108px;
            text-align: center;
            font-family: PingFangSC-Regular;
            font-size: 42px;
            color: #1F1F1F;
            letter-spacing: 0;
            text-align: center;
            line-height: 108px;
            font-weight: 400;
            overflow: hidden;
            white-space: nowrap;
            text-overflow:ellipsis;
        }
    }
    .rank-relevant-list-content {
        .rank-relevant-list-item {
            width: 1140px;
            height: 188px;
            display: flex;
            position: relative;
            margin-bottom: 54px;
            align-items: center;
            .rank-relevant-list-item-num {
                width: 61px;
                height: 64px;
                margin-right: 45px;
            }
            .rank-relevant-list-num-else {
                height: 45px;
                font-family: PingFangSC-Semibold;
                font-size: 45px;
                color: #1F1F1F;
                letter-spacing: 0;
                text-align: center;
                line-height: 45px;
                font-weight: 600;
                margin-right: 65px;
                margin-left: 17px;
                text-align: center;
            }
            .rank-relevant-list-num-else-long {
                height: 45px;
                font-family: PingFangSC-Semibold;
                font-size: 45px;
                color: #1F1F1F;
                letter-spacing: 0;
                text-align: center;
                line-height: 45px;
                font-weight: 600;
                margin-right: 48px;
                margin-left: 17px;
                text-align: center;
            }
            .rank-relevant-list-item-icon {
                width: 188px;
                height: 188px;
                border-radius: 21.94px;
            }
            .rank-relevant-list-item-desc {
                margin-left: 36px;
                .rank-relevant-list-item-name {
                    max-width: 500px;
                    white-space: nowrap;
                    text-overflow:ellipsis;
                    overflow: hidden;
                    height: 48px;
                    font-family: PingFangSC-Regular;
                    font-size: 48px;
                    color: #1F1F1F;
                    letter-spacing: 0;
                    line-height: 48px;
                    font-weight: 400;
                }
                .rank-relevant-list-item-recommend {
                    margin: 27px 0;
                    height: 39px;
                    font-family: PingFangSC-Regular;
                    font-size: 39px;
                    color: #858585;
                    letter-spacing: 0;
                    line-height: 39px;
                    font-weight: 400;
                    .rank-relevant-list-item-recommend-num {
                        color: #3388FF;
                    }
                }
                .rank-relevant-list-item-recommend-reason {
                        max-width: 550px;
                        white-space: nowrap;
                        text-overflow:ellipsis;
                        overflow: hidden;
                    .rank-relevant-list-item-recommend-reason-left {
                        width: 195px;
                        height: 39px;
                        font-family: PingFangSC-Semibold;
                        font-size: 39px;
                        color: #858585;
                        letter-spacing: 0;
                        line-height: 39px;
                        font-weight: 600;
                    }
                    .rank-relevant-list-item-recommend-reason-right {
                        height: 39px;
                        font-family: PingFangSC-Regular;
                        font-size: 39px;
                        color: #858585;
                        letter-spacing: 0;
                        line-height: 39px;
                        font-weight: 400;
                    }
                }
            }
            .rank-relevant-list-item-download-btn {
                height: 84px;
                box-sizing: border-box;
                color: #fff;
                background: #4e6ef2;
                font-family: PingFangSC-Medium;
                font-size: 42px;
                letter-spacing: 0;
                text-align: center;
                line-height: 42px;
                font-weight: 500;
                padding: 21px 44px;
                position: absolute;
                top: 52px;
                right:0;
                border-radius: 300px;
            }
        }
    }
    .showMore {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 62px;
            .showMoreWords {
                height: 48px;
                font-family: PingFangSC-Regular;
                font-size: 48px;
                color: #858585;
                text-align: justify;
                line-height: 48px;
                font-weight: 400;
                margin-right: 18px;
            }
            .showMoreIcon {
                width: 44px;
                height: 24px;
            }
        }
}
</style>